

import type { LootTable, LootRow, ReputationUpgradeId } from "./types";
import type { Rng } from "./dice";
import { defaultRng, rollInt } from "./dice";

export const LOOT_TABLES: Record<string, LootTable> = {
  goblin: [
    { rollMin: 1, rollMax: 60, kind: "nothing", label: "Ничего" },
    { rollMin: 61, rollMax: 85, kind: "gold", payload: { goldMin: 20, goldMax: 60 }, label: "Золото" },
    { rollMin: 86, rollMax: 100, kind: "card", label: "Карта" },
  ],
  wolf: [
    { rollMin: 1, rollMax: 55, kind: "nothing", label: "Ничего" },
    { rollMin: 56, rollMax: 85, kind: "gold", payload: { goldMin: 10, goldMax: 40 }, label: "Золото" },
    { rollMin: 86, rollMax: 100, kind: "card", label: "Карта" },
  ],
};

export interface LootResult {
  row: LootRow;
  
  count: number;
  
  cardIds?: string[];
  cardChoicePool?: string[];
  equipmentId?: string;
  goldAmount?: number;
}


export function rollLoot(
  table: LootTable,
  rng: Rng = defaultRng,
  upgrades?: Partial<Record<ReputationUpgradeId, number>>,
  cardPool?: string[],
): LootResult {
  let roll = rollInt(1, 100, rng);

  const hunterLvl = upgrades?.hunter_luck ?? 0;
  for (let i = 0; i < hunterLvl; i++) {
    const bonus = rollInt(1, 100, rng);
    roll = Math.max(roll, bonus);
  }

  const sharpLvl = upgrades?.sharp_eye ?? 0;
  const sharpThreshold = 50 + 10 * sharpLvl;
  if (sharpLvl > 0 && roll < sharpThreshold) {
    const reroll = rollInt(1, 100, rng);
    roll = Math.max(roll, reroll);
  }

  const row = table.find((r) => roll >= r.rollMin && roll <= r.rollMax);
  if (!row) {
    return { row: { rollMin: 1, rollMax: 100, kind: "nothing", label: "Ничего" }, count: 0 };
  }

  const result: LootResult = { row, count: 1 };

  switch (row.kind) {
    case "nothing":
      result.count = 0;
      break;
    case "card": {
      const pool = cardPool ?? [];
      result.count = pool.length > 0 ? 1 : 0;
      result.cardChoicePool = pool;
      break;
    }
    case "equipment": {
      const pool = row.payload?.equipmentIds ?? [];
      if (pool.length > 0) {
        result.equipmentId = pool[rollInt(0, pool.length - 1, rng)];
      }
      break;
    }
    case "gold": {
      const min = row.payload?.goldMin ?? 0;
      const max = row.payload?.goldMax ?? 0;
      result.goldAmount = rollInt(min, max, rng);
      break;
    }
  }

  return result;
}

export function getLootTable(id: string): LootTable {
  return LOOT_TABLES[id] ?? LOOT_TABLES["goblin"];
}
